/* eslint-disable react-hooks/rules-of-hooks */

import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useLanguage } from "../store/language-context";

const fetcher = async (url) => {
    const response = await axios.get(url);
    return response.data?.data?.data;
};

const useAllLists = ({ includeWhat = [], perPage = 150 }) => {
    const { URL, lang } = useLanguage();
    const { data: cities, isLoading: cLoad, error: cErr } = includeWhat.includes('cities')
        ? useQuery({
            queryKey: ['cities', perPage, URL, lang],
            queryFn: () => fetcher(`${URL}/cities?per_page=${perPage}`),
            staleTime: 15 * 60 * 1000, // 15 min
            cacheTime: 30 * 60 * 1000, // 30 min
        }) : {};

    const { data: categories, isLoading: catLoad, error: catErr } = includeWhat.includes('categories')
        ? useQuery({
            queryKey: ['categories', perPage, URL, lang],
            queryFn: () => fetcher(`${URL}/categories?per_page=${perPage}`),
            staleTime: 15 * 60 * 1000, // 15 min
            cacheTime: 30 * 60 * 1000, // 30 min
        }) : {};

    // const { data: subjects, isLoading: sLoad, error: sErr } = includeWhat.includes('subjects')
    //     ? useQuery({
    //         queryKey: ['subjects', perPage],
    //         queryFn: () => fetcher(`${URL}/ar/subjects?per_page=${perPage}`),
    //         staleTime: 15 * 60 * 1000, // 15 min
    //         cacheTime: 30 * 60 * 1000, // 30 min
    //     }) : null;

    const { data: dependencies, isLoading: dLoad, error: dErr } = includeWhat.includes('dependencies')
        ? useQuery({
            queryKey: ['dependencies', perPage, URL, lang],
            queryFn: () => fetcher(`${URL}/dependencies?per_page=${perPage}`),
            staleTime: 15 * 60 * 1000, // 15 min
            cacheTime: 30 * 60 * 1000, // 30 min
        }) : {};

    return {
        cities, cErr, cLoad,
        categories, catErr, catLoad,
        // subjects, sLoad, sErr,
        dependencies, dLoad, dErr,
        refetchCities: cities?.refetch,
        refetchCategories: categories?.refetch,
        // refetchSubjects: subjects?.refetch,
        refetchDependencies: dependencies?.refetch,
    }
};

export default useAllLists;